import { endPoints } from '@/api/configs';
import { Params } from '../types';

export const customTitleHandler = ({ resource, action }: Params) => {
  let title = 'DIJO Dashboard';
  if (resource && action) {
    title = `${resource.meta?.label} `;
  }

  return title;
};
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);

  // Format the date to 'YYYY-MM-DD'
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  // Format the time to 'HH:MM:SS'
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  // Combine the date and time
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Byte ranges are negotiated by the browser through the HTTP `Range` header,
// which the API already honours (it responds 206 + Content-Range). The old
// `?range=` query param was never implemented server-side and the API's
// validation pipe rejects unknown query params, so it is not offered here.
export const getFileUrl = (id: string) =>
  `${import.meta.env.VITE_API_URL}${endPoints.upload(id)}`;

export const joinMaxThree = (
  items: any[],
  separator: string = ', '
): string => {
  if (!items || items.length === 0) return '';

  const maxItems = items?.slice(0, 3);
  const remaining = items?.length > 3 ? ` +${items?.length - 3}` : '';

  return maxItems.join(separator) + remaining;
};
